import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

import { riskLevelToColor } from '@/lib/ui/color'

import type { DisplayRisk } from '@/components/shared/risk-badge/types'

export const getRiskColor = (risk: RiskLevel): string =>
  riskLevelToColor[risk] || riskLevelToColor[RiskLevel.LOW]

export const isEstimatedRisk = (validatedRisk: RiskLevel | undefined): boolean =>
  validatedRisk === undefined

export const getInherentRisk = (
  validatedRisk: RiskLevel | undefined,
  calculatedRisk: RiskLevel | undefined,
): RiskLevel => validatedRisk ?? calculatedRisk ?? RiskLevel.UNSPECIFIED

export const toDisplayRisk = (
  validatedRisk: RiskLevel | undefined,
  calculatedRisk: RiskLevel | undefined,
): DisplayRisk => ({
  riskLevel: getInherentRisk(validatedRisk, calculatedRisk),
  isEstimated: validatedRisk === undefined,
})
